import { createFileRoute } from "@tanstack/react-router";

import NoAccessPage from "@/components/pages/NoAccessPage";

export const Route = createFileRoute("/no-access")({
  validateSearch: (search: Record<string, unknown>): { restricted: boolean } => {
    return {
      restricted: search.restricted === true || search.restricted === "true",
    };
  },
  component: NoAccessPage,
});
